// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoContainer[data-v-76787aba]{padding:13px 0}.infoContainer p[data-v-76787aba]{margin:0}.infoContainer .top p[data-v-76787aba]{text-align:center}.infoContainer .top .van-button[data-v-76787aba]{width:86px}.infoContainer .right h4[data-v-76787aba]{margin:0 0 10px}.infoContainer .right p[data-v-76787aba]{font-size:14px}[data-v-76787aba]:export{green:#1989fa;white:#fff}", ""]);
// Exports
module.exports = exports;
